import { CityFromSection } from "hooks/returnCityName"
import { ProjectFiles } from "./ProjectFiles"
import ProjectPackage from "./ProjectPackage"
import ProjectSendToGas from "./ProjectSendToGas"
import ProjectSubmitAdmin from "./ProjectSubmitAdmin"
import { ProjectDetail } from "./ProjectDetail"
import { ProjectProcess } from "./ProjectProcess"
import ProjectDelete from "./ProjectDelete"
import { ProjectEdit } from "./ProjectEdit"
import ResolvedDefect from "./ResovedDefect"
import PrepareForMapStage from "./PrepareForMapStage"
import { StopGasProject } from "./StopGasProject"
import { Row, Tag, Collapse, Space, Typography } from "antd"
import ResetPackage from "./ResetPackage"
import PrepareForFirstSuperVisionStage from "./PrepareForFirstSuperVisionStage"

const { Text } = Typography



export const renderFileButton = (params, { props, setErrorMessage }) => {
  return (
    <ProjectFiles
      rowData={params}
      mainProps={props}
      setErrorMessage={setErrorMessage}
    />
  )
}
export const renderPackageButton = (params, { props, setErrorMessage }) => {
  return (
    <div className="d-flex flex-column gap-2 justify-content-center align-items-center">
      <ProjectPackage
        rowData={params}
        mainProps={props}
        setErrorMessage={setErrorMessage}
      />

    </div>
  )
}

export const renderSendToGasButton = (params, { props, setErrorMessage }) => {
  return (
    <ProjectSendToGas
      rowData={params}
      mainProps={props}
      setErrorMessage={setErrorMessage}
    />
  )
}

export const renderResolvedDefectButton = (
  params,
  { props, setErrorMessage }
) => {
  return (
    <ResolvedDefect
      rowData={params}
      mainProps={props}
      setErrorMessage={setErrorMessage}
    />
  )
}

export const renderPrepareMapStageButton = (
  params,
  { props, setErrorMessage }
) => {
  return (
    <PrepareForMapStage
      rowData={params}
      mainProps={props}
      setErrorMessage={setErrorMessage}
    />
  )
}

export const renderPrepareFirstSupervisionStageButton = (
  params,
  { props, setErrorMessage }
) => {
  return (
    <PrepareForFirstSuperVisionStage
      rowData={params}
      mainProps={props}
      setErrorMessage={setErrorMessage}
    />
  )
}

export const renderFloorNumber = params => {
  if (params.row.floorNumber == 0 && params.row.unitNumber == 1)
    return <small>همکف</small>
  if (params.row.floorNumber == 0 && params.row.unitNumber > 1)
    return <small>چند واحدی</small>
  return params.row.floorNumber
}

export const renderExeFullName = (params, props) => {
  return params.row.executor.fullName
}

export const renderProjectProcess = (params, { props }) => {
  return <ProjectProcess rowData={params} mainProps={props} />
}

export const renderDetailButton = (params, props) => {
  return (
    <ProjectDetail
      rowData={params}
      mainProps={props}
      isReadOnly={params.row.projectLevel === 2}
    />
  )
}

export const renderSubmitAdminButton = (params, { props, setErrorMessage }) => {
  return (
    <ProjectSubmitAdmin
      rowData={params}
      mainProps={props}
      setErrorMessage={setErrorMessage}
    />
  )
}

export const renderDeleteButton = (params, { props }) => {
  return <ProjectDelete rowData={params} mainProps={props} />
}

export const renderEditButton = (params, { props }) => {
  return <ProjectEdit rowData={params} mainProps={props} />
}

export const renderStopGasProjectButton = (row, { props, setErrorMessage }) => {
  return (
    <StopGasProject
      rowData={row}
      mainProps={props}
      setErrorMessage={setErrorMessage}
    />
  )
}

export const renderResetPackageButton = (row, { props, setErrorMessage }) => {
  return (
    <ResetPackage
      rowData={row}
      mainProps={props}
      setErrorMessage={setErrorMessage}
    />
  )
}

export const renderAllColumn = (params, props) => {
  const row = params.row
  const isExpanded = props.expanded === `panel${row.fileNumber}`
  return (
    <div
      style={{
        background: row.isCancel ? "#e1e0c9" : "#fff",
        borderRadius: 10,
        padding: 8,
        width: "100%",
      }}
    >
      <div style={{ marginBottom: 6 }}>
        <Text type="secondary" style={{ fontSize: 12 }}>توضیحات: {row.des1}</Text>
      </div>

      <Space wrap size={4} style={{ marginBottom: 6 }}>
        {renderEditButton(params, props)}
        {renderDetailButton(params, props)}
        {renderFileButton(params, props)}
        <Tag>{row.projectLevel}</Tag>
      </Space>

      <Collapse
        ghost
        activeKey={isExpanded ? ["1"] : []}
        onChange={() =>
          props.handleChangeExpand(`panel${row.fileNumber}`)(
            null,
            !isExpanded
          )
        }
        items={[{
          key: "1",
          label: (
            <Text
              style={{
                fontSize: 12,
                color: isExpanded ? "green" : undefined,
              }}
            >
              مالک: {row.landlordName} / کارشناس:{" "}
              {row.engFullName
                ? row.engFullName + " " + row.engCellPhone
                : "مشخص نشده"}
            </Text>
          ),
          children: (
            <Row gutter={[8, 8]} style={{ textAlign: "right", fontSize: 12 }}>
              <Row style={{ width: "100%" }} gutter={[8, 4]}>
                <span style={{ marginLeft: 8 }}>طبقه: {renderFloorNumber(params)}</span>
                <span style={{ marginLeft: 8 }}>واحد: {row.unitNumber}</span>
                <span style={{ marginLeft: 8 }}>مجری: {renderExeFullName(params, props)}</span>
                <span style={{ marginLeft: 8 }}>شهر: {CityFromSection(row.idSection)}</span>
                <span style={{ marginLeft: 8 }}>مالکیت: {row.ownershipType}</span>
                <span style={{ marginLeft: 8 }}>کاربری: {row.buildingType}</span>
              </Row>
              <Space wrap size={4} style={{ marginTop: 6 }}>
                {renderProjectProcess(params, props)}
                {row.packageNeed && renderPackageButton(params, props)}
                {renderSendToGasButton(params, props)}
                <span>درخواست نظارت: {renderPrepareFirstSupervisionStageButton(params, props)}</span>
                <span>درخواست نقشه: {renderPrepareMapStageButton(params, props)}</span>
                <span>رفع نقص: {renderResolvedDefectButton(params, props)}</span>
                {renderDeleteButton(params, props)}
                {props.currentUser.role === "Administrator" &&
                  renderSubmitAdminButton(params, props)}
              </Space>
            </Row>
          ),
        }]}
      />
    </div>
  )
}
export const mobileColumn = props => {
  const isMobile = props.matches_sm
  const role = props.currentUser.role
  const isAdmin = role === "Administrator"
  const isEmployee = role === "Employee"

  // Mobile: single combined column
  if (isMobile) {
    return [
      {
        title: "اطلاعات پرونده",
        key: "allColumn",
        render: (_, record) => renderAllColumn({ row: record }, props),
      },
    ]
  }

  // Desktop: individual columns
  const columns = [
    {
      title: "شماره پرونده",
      dataIndex: "fileNumber",
      key: "fileNumber",
      width: 120,
      render: (_, record) => renderEditButton({ row: record }, props),
    },
    {
      title: "توضیحات",
      dataIndex: "des1",
      key: "des4",
      width: 200,
      render: val => (
        <div style={{ maxHeight: 50, overflowY: "auto", fontSize: 12 }}>{val}</div>
      ),
    },
    {
      title: "تاییدواحدگاز",
      dataIndex: "isOk",
      key: "isOk",
      width: 100,
      render: val => (
        <Tag color={val ? "success" : "error"}>{val ? "بله" : "خیر"}</Tag>
      ),
    },
    !isEmployee && {
      title: "ارسال-نقشه",
      key: "sendToGas",
      width: 130,
      render: (_, record) =>
        record.isOk
          ? renderSendToGasButton({ row: record }, props)
          : <Tag color="default">تایید نشده</Tag>,
    },
    isAdmin && {
      title: "تایید",
      key: "submitAdmin",
      render: (_, record) => renderSubmitAdminButton({ row: record }, props),
    },
    isAdmin && {
      title: "توقف",
      key: "isStop",
      render: (_, record) => renderStopGasProjectButton({ row: record }, props),
    },
    isAdmin && {
      title: "ریست پکیج",
      key: "resetPackage",
      render: (_, record) => renderResetPackageButton({ row: record }, props),
    },
    {
      title: "الزامات",
      key: "Detail",
      render: (_, record) => renderDetailButton({ row: record }, props),
    },
    {
      title: "رفع نقص",
      key: "resolvedDefect",
      render: (_, record) => renderResolvedDefectButton({ row: record }, props),
    },
    {
      title: "ثبت نقشه",
      key: "prepareForMapStage",
      render: (_, record) => renderPrepareMapStageButton({ row: record }, props),
    },
    {
      title: "درخواست نظارت",
      key: "PrepareForFirstSuperVisionStage",
      width: 130,
      render: (_, record) => renderPrepareFirstSupervisionStageButton({ row: record }, props),
    },
    {
      title: "درخواست طراحی",
      dataIndex: "isPrepareForDesignStage",
      key: "IsPrepareForDesignStage",
      width: 120,
      render: (val, record) => (
        <Tag>{val ? record.solarPrepareForDesignStage : "ندارد"}</Tag>
      ),
    },
    {
      title: "واحد/طبقه",
      key: "unitNumber",
      render: (_, record) => (
        <Row gutter={[4, 2]} className="flex-row-reverse">
          <Tag>{record.unitNumber}</Tag>
          <Tag>{record.floorNumber}</Tag>
        </Row>
      ),
    },
    {
      title: "نظرکارشناس",
      key: "ProjectProcess",
      render: (_, record) => renderProjectProcess({ row: record }, props),
    },
    {
      title: "فایلها",
      key: "File",
      width: 90,
      render: (_, record) => renderFileButton({ row: record }, props),
    },
    {
      title: "تاییدنصاب",
      key: "Package",
      render: (_, record) => renderPackageButton({ row: record }, props),
    },
    {
      title: "نام نصاب",
      key: "PackageInstallerName",
      render: (_, record) => record.packageInstaller?.fullName,
    },
    {
      title: "مالک",
      dataIndex: "landlordName",
      key: "landlordName",
      width: 120,
    },
    {
      title: "مجری",
      key: "exeFullName",
      width: 120,
      render: (_, record) => renderExeFullName({ row: record }, props),
    },
    {
      title: "تعرفه",
      dataIndex: "inspectionParameterType",
      key: "inspectionParameterType",
      width: 70,
    },
    {
      title: "نوع کاربری",
      dataIndex: "buildingType",
      key: "buildingType",
      width: 80,
    },
    {
      title: "مرحله پرونده",
      dataIndex: "projectLevel",
      key: "projectLevel",
      width: 140,
    },
    {
      title: "دلیل عدم تایید",
      dataIndex: "disapprovalTypeName",
      key: "disapprovalTypeName",
      width: 130,
    },
    {
      title: "موبایل",
      dataIndex: "engCellPhone",
      key: "engCellPhone",
    },
    {
      title: "کارشناس",
      dataIndex: "engFullName",
      key: "engFullName",
    },
    !isAdmin && !isEmployee && {
      title: "حذف",
      key: "Delete",
      render: (_, record) => renderDeleteButton({ row: record }, props),
    },
  ]

  return columns.filter(Boolean)
}
